<template>
  <b-tab title="ТИПОВОЙ Договор ТЭО Экспедитор">
    <HeaderBlock :docHistory.sync="docHistory" class="mb-4" />
    <Block_10 :docHistory.sync="docHistory" class="mb-4" />
    <Application_1 :docHistory.sync="docHistory" class="mb-4" />
  </b-tab>
</template>

<script>
import HeaderBlock from '@components/companies/contracts/typdogteoexp/HeaderBlock';
import Block_10 from '@components/companies/contracts/typdogteoexp/Block_10';
import Application_1 from '@components/companies/contracts/typdogteoexp/Application_1';

export default {
  components: {
    HeaderBlock,
    Block_10,
    Application_1,
  },
  data() {
    return {
      predprosmotr: false,
    }
  },
  props: {
    docHistory: {
      type: Object,
      required: true,
    },
  },
}
</script>
